import { useState } from "react";
import Link from "next/link";
import styled, { css } from "styled-components";
import { useRouter } from "next/router";

import { HamburgerIcon } from "./HamburgerIcon";

const Header = styled.header<{ open: boolean }>`
  position: fixed;
  top: 0;
  right: -60%;
  height: 100%;
  width: 60%;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.5s ease-in-out;
  z-index: 100;
  -webkit-box-shadow: -8px 0px 18px -10px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -8px 0px 18px -10px rgba(0, 0, 0, 0.75);
  box-shadow: -8px 0px 18px -10px rgba(0, 0, 0, 0.75);
  ${(props) =>
    props.open
      ? css`
          transition: transform 0.4s ease-in-out;
          transform: translateX(-100%);
        `
      : ""}
`;

const Ul = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  height: 50%;
`;

const A = styled.a`
  color: #a6a6a6;
  text-transform: uppercase;
  font-size: 2.3rem;
  &.active {
    color: grey;
  }
`;

export const MobileHeader = () => {
  const [open, setOpen] = useState(false);
  const router = useRouter();

  return (
    <>
      <HamburgerIcon open={open} onClick={() => setOpen(!open)} />
      <Header open={open}>
        <Ul>
          <li>
            <Link href="/shop">
              <A
                className={
                  router.pathname.split("/")[1].includes("shop") ? "active" : ""
                }
                onClick={() => setOpen(false)}
              >
                Shop
              </A>
            </Link>
          </li>
          <li>
            <Link href="/lookbook">
              <A
                className={
                  router.pathname.split("/")[1].includes("lookbook")
                    ? "active"
                    : ""
                }
                onClick={() => setOpen(false)}
              >
                Lookbook
              </A>
            </Link>
          </li>
          <li>
            <Link href="/">
              <A
                className={router.pathname.split("/")[1] === "" ? "active" : ""}
                onClick={() => setOpen(false)}
              >
                Home
              </A>
            </Link>
          </li>
          <li>
            <Link href="/contact">
              <A
                className={
                  router.pathname.split("/")[1].includes("contact")
                    ? "active"
                    : ""
                }
                onClick={() => setOpen(false)}
              >
                Cont*ct
              </A>
            </Link>
          </li>
        </Ul>
      </Header>
    </>
  );
};
